import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTile from './DashboardTile';
import CubeRotator from './CubeRotator';
import type { LatestCourse } from '@/types/dashboard';

interface LatestCoursesCubeProps {
  courses: LatestCourse[];
}

const CourseFace: FC<{ course: LatestCourse; onClick: () => void }> = ({ course, onClick }) => (
  <div
    className="w-full h-full flex flex-col justify-between p-1 cursor-pointer"
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}
  >
    <div>
      <span
        className="inline-block text-2xs font-black uppercase tracking-widest px-2 py-0.5 rounded mb-2"
        style={{ background: 'var(--tile-accent)', color: 'var(--tile-bg)' }}
      >
        Novo
      </span>
      <p className="text-2xs font-bold uppercase tracking-[0.1em] mb-1" style={{ color: 'var(--tile-text-muted)' }}>
        Novo Curso
      </p>
      <p className="text-sm font-bold leading-tight line-clamp-2" style={{ color: 'var(--tile-text-primary)' }}>
        {course.title}
      </p>
    </div>
    <div className="flex items-center gap-2 text-2xs" style={{ color: 'var(--tile-text-secondary)' }}>
      <span>{course.level}</span>
      <span>·</span>
      <span>{course.duration_minutes}min</span>
      <span>·</span>
      <span style={{ color: 'var(--tile-accent)' }}>{course.xp_reward} XP</span>
    </div>
  </div>
);

const EmptyFace: FC = () => (
  <div className="w-full h-full flex flex-col items-center justify-center p-1">
    <span className="material-symbols-outlined text-2xl mb-1" style={{ color: 'var(--tile-text-muted)' }}>school</span>
    <p className="text-xs text-center" style={{ color: 'var(--tile-text-muted)' }}>Novos cursos em breve</p>
  </div>
);

const LatestCoursesCube: FC<LatestCoursesCubeProps> = ({ courses }) => {
  const navigate = useNavigate();

  // Pad to 3 faces
  const faces = [];
  for (let i = 0; i < 3; i++) {
    const course = courses[i % courses.length];
    if (course) {
      faces.push(
        <CourseFace key={i} course={course} onClick={() => navigate(`/trilhas/${course.id}`)} />
      );
    } else {
      faces.push(<EmptyFace key={i} />);
    }
  }

  return (
    <DashboardTile data-testid="latest-courses-tile">
      <CubeRotator faces={faces} interval={9000} height={150} />
    </DashboardTile>
  );
};

export default LatestCoursesCube;
